var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle5, _circle6, _circle7, _circle8, _path14, _path15, _path16, _path17, _circle9, _path18, _circle10, _path19, _circle11, _path20, _circle12, _path21, _circle13, _path22, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 526,
    height: 510,
    viewBox: "0 0 526 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.275 103.623C284.622 99.3796 291.352 93.4385 299.499 103.623H282.275Z",
    fill: "#30235B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M269.149 190.907C263.757 190.907 261.041 186.657 260.351 184.76C259.557 183.173 258.931 179.038 260.81 175.753C263.199 171.577 274.428 170.412 278.362 176.312C282.295 182.212 278.362 190.907 269.149 190.907Z",
    fill: "#E6FCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.715 169.875C177.915 166.467 178.594 163.613 179.161 162.027C180.273 164.809 180.823 167.48 181.009 169.915C183.445 170.101 186.116 170.651 188.897 171.764C187.311 172.331 184.458 173.01 181.049 173.21C180.859 176.828 179.929 179.64 179.161 181.08C178.226 178.463 177.799 175.772 177.688 173.236C175.153 173.125 172.461 172.699 169.844 171.764C171.285 170.996 174.096 170.065 177.715 169.875Z",
    fill: "url(#paint0_linear_4240_27)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.828 147.449C150.96 145.18 151.413 143.28 151.79 142.225C152.53 144.076 152.896 145.854 153.02 147.475C154.641 147.599 156.419 147.965 158.271 148.706C157.215 149.083 155.316 149.535 153.047 149.668C152.92 152.077 152.301 153.948 151.79 154.907C151.167 153.165 150.884 151.373 150.81 149.686C149.122 149.612 147.33 149.328 145.588 148.706C146.547 148.195 148.419 147.575 150.828 147.449Z",
    fill: "url(#paint1_linear_4240_27)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.504 131.471C107.704 128.062 108.383 125.209 108.95 123.623C110.062 126.405 110.613 129.075 110.798 131.511C113.234 131.697 115.905 132.247 118.687 133.36C117.101 133.926 114.247 134.606 110.839 134.805C110.648 138.424 109.718 141.236 108.95 142.676C108.015 140.059 107.589 137.367 107.477 134.832C104.942 134.721 102.25 134.294 99.6336 133.36C101.074 132.592 103.886 131.661 107.504 131.471Z",
    fill: "url(#paint2_linear_4240_27)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.213 209.812C111.507 204.797 112.506 200.599 113.34 198.265C114.977 202.358 115.786 206.287 116.06 209.871C119.643 210.144 123.572 210.954 127.665 212.591C125.332 213.424 121.134 214.424 116.119 214.717C115.839 220.041 114.47 224.178 113.34 226.297C111.965 222.447 111.337 218.487 111.174 214.757C107.444 214.593 103.484 213.966 99.6336 212.591C101.752 211.461 105.889 210.091 111.213 209.812Z",
    fill: "url(#paint3_linear_4240_27)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 141.682,
    cy: 180.157,
    r: 1.8414,
    fill: "#2F235A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.94,
    cy: 127.36,
    r: 1.8414,
    fill: "#FE9076"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.3205,
    cy: 172.847,
    r: 1.8414,
    fill: "#FFA400"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.847,
    cy: 208.557,
    r: 1.8414,
    fill: "#1565C0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.428 119.675C175.265 113.957 163.538 101.744 149.934 98.6345",
    stroke: "#F53838",
    strokeWidth: 1.60277,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5511 167.911C77.3979 164.424 61.6733 158.145 48 160.933",
    stroke: "#F53838",
    strokeWidth: 1.60277,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.527 213.906C164.374 216.688 156.788 224.59 151.669 233.937",
    stroke: "#1565C0",
    strokeWidth: 1.60277,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.065 169.875C394.866 166.467 394.186 163.613 393.62 162.027C392.507 164.809 391.957 167.48 391.771 169.915C389.335 170.101 386.664 170.651 383.883 171.764C385.469 172.331 388.322 173.01 391.731 173.21C391.921 176.828 392.851 179.64 393.62 181.08C394.554 178.463 394.981 175.772 395.092 173.236C397.627 173.125 400.319 172.699 402.936 171.764C401.496 170.996 398.684 170.065 395.065 169.875Z",
    fill: "url(#paint4_linear_4240_27)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.953 147.449C421.82 145.18 421.368 143.28 420.991 142.225C420.25 144.076 419.884 145.854 419.76 147.475C418.139 147.599 416.361 147.965 414.509 148.706C415.565 149.083 417.464 149.535 419.733 149.668C419.86 152.077 420.479 153.948 420.991 154.907C421.613 153.165 421.896 151.373 421.971 149.686C423.658 149.612 425.45 149.328 427.192 148.706C426.233 148.195 424.361 147.575 421.953 147.449Z",
    fill: "url(#paint5_linear_4240_27)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.276 131.471C465.076 128.062 464.397 125.209 463.83 123.623C462.718 126.405 462.168 129.075 461.982 131.511C459.546 131.697 456.875 132.247 454.093 133.36C455.679 133.926 458.533 134.606 461.942 134.805C462.132 138.424 463.062 141.236 463.83 142.676C464.765 140.059 465.191 137.367 465.303 134.832C467.838 134.721 470.53 134.294 473.146 133.36C471.706 132.592 468.895 131.661 465.276 131.471Z",
    fill: "url(#paint6_linear_4240_27)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.567 209.812C461.273 204.797 460.274 200.599 459.44 198.265C457.803 202.358 456.994 206.287 456.72 209.871C453.137 210.144 449.208 210.954 445.115 212.591C447.448 213.424 451.646 214.424 456.661 214.717C456.941 220.041 458.31 224.178 459.44 226.297C460.815 222.447 461.443 218.487 461.606 214.757C465.336 214.593 469.296 213.966 473.146 212.591C471.028 211.461 466.891 210.091 461.567 209.812Z",
    fill: "url(#paint7_linear_4240_27)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.8414,
    cy: 1.8414,
    r: 1.8414,
    transform: "matrix(-1 0 0 1 432.939 178.316)",
    fill: "#2F235A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.8414,
    cy: 1.8414,
    r: 1.8414,
    transform: "matrix(-1 0 0 1 390.681 125.518)",
    fill: "#F53838"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.8414,
    cy: 1.8414,
    r: 1.8414,
    transform: "matrix(-1 0 0 1 483.301 171.005)",
    fill: "#FFA400"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.8414,
    cy: 1.8414,
    r: 1.8414,
    transform: "matrix(-1 0 0 1 400.775 206.716)",
    fill: "#F53838"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M393.352 119.675C397.515 113.957 409.242 101.744 422.846 98.6345",
    stroke: "#F53838",
    strokeWidth: 1.60277,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M489.229 167.911C495.382 164.424 511.107 158.145 524.78 160.933",
    stroke: "#F53838",
    strokeWidth: 1.60277,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M405.253 213.906C408.406 216.688 415.992 224.59 421.111 233.937",
    stroke: "#F53838",
    strokeWidth: 1.60277,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M316.426 56.1737C314.338 52.9483 310.112 54.7054 310.112 58.2189C310.112 60.8572 315.906 64.9844 316.426 65.521C316.95 64.9844 322.456 60.8572 322.456 58.2189C322.456 54.732 318.518 52.9483 316.426 56.1737Z",
    fill: "#1565C0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.284,
    cy: 59.9987,
    r: 13.7999,
    stroke: "#F7F7F7",
    strokeWidth: 0.649684
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M266.903 36.9405C265.055 34.0859 261.315 35.641 261.315 38.7506C261.315 41.0856 266.443 44.7383 266.903 45.2132C267.367 44.7383 272.24 41.0856 272.24 38.7506C272.24 35.6645 268.755 34.0859 266.903 36.9405Z",
    fill: "#1565C0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.777,
    cy: 40.3258,
    r: 12.2135,
    stroke: "#F7F7F7",
    strokeWidth: 0.574998
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M299.586 15.9654C298.322 14.0131 295.763 15.0766 295.763 17.2034C295.763 18.8004 299.271 21.2986 299.586 21.6234C299.903 21.2986 303.235 18.8004 303.235 17.2034C303.235 15.0928 300.852 14.0131 299.586 15.9654Z",
    fill: "#1565C0"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.499,
    cy: 18.2808,
    r: 8.35318,
    stroke: "#F7F7F7",
    strokeWidth: 0.393259
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M241.856 5.10129C240.822 3.50382 238.729 4.37407 238.729 6.11426C238.729 7.421 241.598 9.46511 241.856 9.7309C242.115 9.46511 244.842 7.421 244.842 6.11426C244.842 4.38726 242.892 3.50382 241.856 5.10129Z",
    fill: "#1565C0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.785,
    cy: 6.99577,
    r: 6.83488,
    stroke: "#F7F7F7",
    strokeWidth: 0.321779
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M236.769 79.9873C234.511 76.4995 229.941 78.3996 229.941 82.1989C229.941 85.0519 236.206 89.5148 236.769 90.0951C237.336 89.5148 243.29 85.0519 243.29 82.1989C243.29 78.4284 239.031 76.4995 236.769 79.9873Z",
    fill: "#1565C0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.615,
    cy: 84.1235,
    r: 14.9226,
    stroke: "#F7F7F7",
    strokeWidth: 0.702541
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4240_27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4240_27",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 117,
    width: 525,
    height: 393
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M524.67 117H0V509.985H524.67V117Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4240_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.06 414.499L116.45 417.719L102.28 408.059L94.0801 417.719L98.0201 438.099L102.52 454.189L129.85 440.309L151.86 438.319L146.06 414.499Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.09 380.369L224.62 379.079L137.69 415.779L149.28 440.899L227.84 418.999L349.53 453.769L332.79 371.359L296.09 380.369Z",
    fill: "#C81640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.05 416.839L114.26 415.729L96.19 377.559C96.19 377.559 87.82 374.599 86.53 383.809C85.24 393.009 96.23 455.339 99.45 455.339C102.67 455.339 113.47 449.039 113.47 449.039L97.48 418.769L100.06 416.839H100.05Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.35 406.389C454.92 406.539 453.36 406.769 451.7 407.109C444.66 408.539 444.52 413.319 444.58 414.409L444.53 414.379C443.82 415.509 443.38 416.659 443.11 417.749L442.79 403.109C443 402.679 443.19 402.179 443.35 401.679C443.88 403.299 444.74 404.829 445.48 404.729C446.45 404.599 446.87 401.749 446.69 399.729C447.92 401.309 449.99 403.009 450.77 402.489C451.39 402.069 451.02 400.349 450.34 398.789C451.76 399.649 453.33 400.209 453.82 399.659C454.49 398.919 452.89 396.389 451.42 394.979C453.39 395.159 455.9 394.849 456.06 393.949C456.2 393.209 454.7 392.279 453.11 391.679C454.71 391.259 456.21 390.519 456.16 389.789C456.1 388.919 453.88 388.339 451.96 388.259C453.41 387.129 454.74 385.559 454.33 384.849C453.96 384.199 452.22 384.449 450.61 385.019C451.56 383.659 452.23 382.129 451.72 381.609C451.09 380.959 448.84 382.079 447.3 383.329C447.6 381.389 447.45 378.939 446.58 378.719C445.85 378.529 444.82 379.959 444.11 381.509C443.8 379.879 443.16 378.339 442.43 378.339C441.39 378.339 440.55 381.479 440.55 383.519V383.849C440.45 383.729 440.33 383.599 440.19 383.469C438.72 382.049 435.89 380.469 435.16 381.209C434.65 381.729 435.32 383.259 436.27 384.619C434.66 384.049 432.92 383.789 432.55 384.449C432.05 385.329 434.2 387.509 435.94 388.569C435.84 388.559 435.72 388.549 435.61 388.539C433.57 388.399 430.38 389.029 430.31 390.069C430.26 390.799 431.76 391.539 433.36 391.959C431.76 392.559 430.27 393.489 430.41 394.229C430.57 395.129 433.08 395.439 435.05 395.259C433.58 396.669 431.98 399.199 432.65 399.939C433.14 400.479 434.71 399.919 436.13 399.069C435.45 400.629 435.08 402.349 435.7 402.769C436.52 403.319 438.79 401.399 439.98 399.749C439.86 401.769 440.34 404.549 441.3 404.659C441.7 404.709 442.13 404.279 442.51 403.619L441.42 419.359C441.17 421.189 442.79 422.389 442.94 423.139L443.17 433.799C442.91 433.039 442.55 432.259 442.07 431.489L442.02 431.519C442.08 430.419 441.94 425.649 434.9 424.219C433.24 423.879 431.68 423.649 430.25 423.499C428.56 423.319 427.9 425.629 429.43 426.379C431.64 427.459 433.72 428.819 434.8 430.429C437.57 434.549 441.39 432.169 441.94 431.799C442.55 432.809 442.95 433.829 443.2 434.799L443.32 440.459C443.29 440.589 443.27 440.669 443.27 440.669L443.33 440.689L443.63 454.389L446.43 454.369L445.43 440.369C445.6 439.609 446.12 437.039 445.43 434.369L444.43 423.369L443.13 419.049C443.32 417.709 443.76 416.209 444.65 414.719C445.19 415.089 449.02 417.469 451.79 413.349C452.87 411.739 454.95 410.379 457.16 409.299C458.68 408.549 458.03 406.239 456.34 406.419V406.389H456.35ZM443.59 438.799L443.54 436.399C443.65 437.309 443.64 438.119 443.59 438.799Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 454.109C0 454.769 0.53 455.299 1.19 455.299H523.48C524.14 455.299 524.67 454.769 524.67 454.109C524.67 453.449 524.14 452.919 523.48 452.919H1.19C0.53 452.919 0 453.449 0 454.109Z",
    fill: "#E2F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.55 294.509L353.64 270.689L374.24 270.039L382.61 299.659L346.55 294.509Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M346.55 294.509L353.64 270.689L374.24 270.039L382.61 299.659L346.55 294.509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.18 291.189L344.7 289.899L334.32 311.249L318.3 405.799L402.33 424.789C402.33 424.789 407.48 319.189 395.89 304.379C384.3 289.569 378.18 291.179 378.18 291.179V291.189Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.12 217.149C278.72 209.699 273.75 204.369 269 205.259C264.25 206.149 261.54 212.909 262.94 220.369C263.46 223.359 264.68 226.169 266.51 228.589L272.82 260.099L285.27 257.569L279.75 226.109C280.58 223.189 280.7 220.119 280.1 217.149H280.12Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.17 299.769L304.79 286.299L285.57 228.499L264.04 233.599L285.64 318.979L363.04 329.159L373.17 299.769Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.03 124.569C268.96 124.639 268.9 124.699 268.83 124.769C258.48 114.489 241.8 114.399 231.33 124.569C220.83 134.769 220.47 151.519 230.53 162.159L230.78 162.419L267.83 200.569L306.24 163.269L306.13 163.159C306.19 163.099 306.26 163.039 306.33 162.979C316.94 152.679 317.18 135.729 306.88 125.129C296.58 114.519 279.63 114.279 269.03 124.579V124.569Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.19 313.769C278.07 313.889 277.95 314.019 277.83 314.139C258.76 295.219 228.05 295.049 208.77 313.769C189.43 332.559 188.77 363.409 207.3 382.999L207.76 383.489L276 453.749L346.73 385.049L346.53 384.849C346.65 384.739 346.77 384.629 346.89 384.519C366.42 365.549 366.88 334.339 347.91 314.799C328.94 295.269 297.73 294.809 278.19 313.779V313.769Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.52 392.079C382.52 392.079 407.79 413.129 398.41 425.899C389.04 438.669 357.16 461.529 342.76 454.439C328.36 447.349 298.47 396.109 298.47 396.109L290.65 448.599L270.19 446.789C270.19 446.789 255.33 372.649 269.03 361.279C282.74 349.909 345.14 370.009 345.14 370.009L382.51 392.089L382.52 392.079Z",
    fill: "#C81640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3 439.819L269.44 458.029L257.23 475.139L266.59 489.149L296.34 469.559L296.24 459.479L291.57 453.189L288.27 441.129L275.3 439.819Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.94 482.249L258.47 470.109L232.75 503.599C232.75 503.599 233.94 512.399 242.72 509.339C251.5 506.279 305.93 478.379 304.46 475.509C302.99 472.639 296.96 457.219 296.96 457.219L268.84 483.649L265.95 482.239L265.94 482.249Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.73 391.909C274.18 392.659 268.45 397.159 268.93 401.959C269.41 406.759 275.91 410.049 283.46 409.299C286.48 409.039 289.39 408.059 291.96 406.449L323.89 402.879L322.44 390.259L290.62 393.049C287.79 391.969 284.74 391.579 281.73 391.919V391.909Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.07 306.329L352.75 373.289L293.51 387.449L296.73 409.349L383.66 395.179L400.47 318.949L372.07 306.329Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.32 277.819C376.43 277.819 388.68 265.57 388.68 250.459C388.68 235.349 376.43 223.099 361.32 223.099C346.209 223.099 333.96 235.349 333.96 250.459C333.96 265.57 346.209 277.819 361.32 277.819Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.5 213.669C362.71 214.129 361.65 213.429 361.39 212.549C361.14 211.669 361.43 210.729 361.73 209.869C362.22 208.409 362.71 206.949 363.21 205.499C364.26 202.399 365.37 199.189 367.64 196.829C371.06 193.269 376.5 192.359 381.4 193.019C387.69 193.859 393.89 197.269 396.82 202.899C399.74 208.529 398.5 216.389 393.22 219.899C400.75 228.529 403.37 238.149 402.96 249.589C402.55 261.039 390.07 271.569 381.94 279.629C380.12 278.529 378.47 273.369 379.47 271.489C380.47 269.619 379.04 267.439 380.27 265.719C381.5 263.999 382.54 266.739 381.29 265.029C380.5 263.949 383.58 261.449 382.41 260.809C376.74 257.669 374.85 250.599 371.28 245.179C366.98 238.649 359.62 234.219 351.84 233.489C347.55 233.089 343.02 233.819 339.51 236.309C335.99 238.799 333.72 243.249 334.53 247.479C332.42 245.339 331.37 242.189 331.76 239.209C332.16 236.229 333.99 233.469 336.59 231.949C335.01 226.729 336.36 220.719 340.03 216.679C343.7 212.639 358.57 213.329 363.92 214.389L363.51 213.679L363.5 213.669Z",
    fill: "#C81640",
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.34 233.639C371.43 234.409 376.55 240.549 380.87 246.219C383.36 249.489 385.97 253.099 385.91 257.209C385.85 261.359 383.07 264.929 381.74 268.869C379.57 275.309 381.68 282.959 386.85 287.369C381.75 288.339 376.23 284.509 375.35 279.389C374.32 273.429 378.84 267.679 378.31 261.649C377.84 256.339 373.66 252.259 370.1 248.289C366.54 244.319 363.21 239.059 364.84 233.989L364.34 233.649V233.639Z",
    fill: "#2F2E41"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4240_27",
    x1: 179.371,
    y1: 164.055,
    x2: 179.371,
    y2: 181.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1565C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1565C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4240_27",
    x1: 151.93,
    y1: 143.575,
    x2: 151.93,
    y2: 155.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B132A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4240_27",
    x1: 109.16,
    y1: 125.651,
    x2: 109.16,
    y2: 143.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4240_27",
    x1: 113.649,
    y1: 201.249,
    x2: 113.649,
    y2: 227.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1565C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4240_27",
    x1: 393.409,
    y1: 164.055,
    x2: 393.409,
    y2: 181.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2576D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D5E8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4240_27",
    x1: 420.85,
    y1: 143.575,
    x2: 420.85,
    y2: 155.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4240_27",
    x1: 463.62,
    y1: 125.651,
    x2: 463.62,
    y2: 143.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4240_27",
    x1: 459.131,
    y1: 201.249,
    x2: 459.131,
    y2: 227.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1565C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1565C0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4240_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 525,
    height: 393,
    fill: "white",
    transform: "translate(0 117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.523bfebd52ed3054609eb5e16eefd718.svg";
export { ForwardRef as ReactComponent };